import { isSensitiveRequestHeader } from '../../common/snapshot-testing/sensitiveRedaction';

export { isSensitiveRequestHeader };

export function shouldHideRequestHeaderValue(header) {
    return isSensitiveRequestHeader(header);
}

export function shouldOmitHeaderFromCurl(header) {
    return String(header).toLowerCase() === 'date' || isSensitiveRequestHeader(header);
}

function escape(str) {
    if (str) {
        return String(str)
            .replace(new RegExp(/"/, 'g'), '\\"')
            .replace(new RegExp(/\$/, 'g'), '\\$')
            .replace(new RegExp(/\!/, 'g'), '\\!')
            .replace(new RegExp(/\n/, 'g'), '\\n');
    }

    return str;
}

export function constructCURL(request, requestContent) {
    let output = "curl -L -k";

    if (request.method !== 'GET') {
        output += ' -X ' + request.method;
    }

    output += " \"" + escape(request.url) + "\"";

    if (requestContent) {
        output += ' --data-raw "' + escape(requestContent) + '"';
    }

    if (request.requestHeaders) {
        for (let header of Object.keys(request.requestHeaders)) {
            if (shouldOmitHeaderFromCurl(header)) {
                continue;
            }

            output += ' -H "' + escape(header) + ': ' + escape(request.requestHeaders[header]) + '"';
        }
    }

    return output;
}
